import { render, staticRenderFns } from "./ExecucaoPausada.vue?vue&type=template&id=c594629e&"
import script from "./ExecucaoPausada.vue?vue&type=script&lang=js&"
export * from "./ExecucaoPausada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports